let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2ncxe")).then(() => parcelRequire('dD9uY'));